import React, { useState, useEffect, useRef } from "react";
import * as appActions from "../../redux/actions/appActions";
import * as cartActions from "../../redux/actions/cartActions";
import * as scuolaActions from "../../redux/actions/scuolaActions";
import * as scuolaNewActions from "../../redux/actions/scuolaNewActions"; // Import Message
import {
  Container,
  Grid,
  Segment,
  Loader,
  Button,
  Divider,
  Image,
} from "semantic-ui-react";
import { connect } from "react-redux";
import TestataPagina from "../common/TestataPagina";
import { useTranslation } from "react-i18next"; // Import moment
import moment from "moment";
import Preferenze from "./Preferenze";
import * as privateNewApi from "../../api/privateNewApi";
import Calendar from "./Calendar";
import { updateTimeRangeWithSlot } from "../../utils/timeRangeUtils";
import Timeline from "../private_new/Timeline";
import GrigliaMaestri from "./GrigliaMaestri";

import { Message } from "semantic-ui-react";

const PrivateNewMain = ({
  codScuola,
  lang,
  datiScuola,
  datiScuolaOld,
  loadSchoolDataNew,
  loadSchoolData,
  loading,
}) => {
  const { t } = useTranslation();

  ////////////////
  //State management
  const [selectedArea, setSelectedArea] = useState(() => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      return "9e27584b-baf7-4421-021c-08ddddc363ea";
    } else {
      return null;
    }
  });
  const [selectedSpecialita, setSelectedSpecialita] = useState(() => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      return "41b00f82-2dd7-45b6-5375-08ddddc363f8";
    } else {
      return null;
    }
  });
  const [selectedLivello, setSelectedLivello] = useState(() => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      return "13e5dfd3-9aea-4395-54da-08ddddc363f1";
    } else {
      return null;
    }
  });

  const [selectedLingua, setSelectedLingua] = useState(1);
  const [selectedNumAllevi, setSelectedNumAllevi] = useState(1);
  const [isPreferenzeValid, setIsPreferenzeValid] = useState(false);
  const [hasBeenInitialized, setHasBeenInitialized] = useState(false);
  const [dateNonDisponibili, setDateNonDisponibili] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const [idMaestro, setIdMaestro] = useState(null);
  const [nomeMaestro, setNomeMaestro] = useState(null);
  const [maestroData, setMaestroData] = useState(null);
  const [disponibilità, setDisponibilità] = useState([]);
  const [primoGiorno, setPrimoGiorno] = useState(null);
  const [firstDayTimeSlots, setFirstDayTimeSlots] = useState([]);
  const [timeRangeFirstDay, setTimeRangeFirstDay] = useState(null);
  const [timeRangesOtherDays, setTimeRangesOtherDays] = useState({});
  const [prezziLezioni, setPrezziLezioni] = useState(null);
  const [isMaestroMode, setIsMaestroMode] = useState(false);
  const [showMaestriModal, setShowMaestriModal] = useState(false);
  // const [tempTimeRangesOtherDays, setTempTimeRangesOtherDays] = useState({});

  ////////////////
  //Helper functions
  const validatePreferences = () => {
    return (
      selectedArea &&
      selectedSpecialita &&
      selectedLivello &&
      selectedLingua &&
      selectedNumAllevi
    );
  };

  const handleRecalculate = () => {
    if (validatePreferences()) {
      setIsPreferenzeValid(true);
    }
  };

  const handleOpenMaestriModal = () => {
    setShowMaestriModal(true);
  };

  const handleCloseMaestriModal = () => {
    setShowMaestriModal(false);
  };

  const handleSelectMaestro = (maestroIdSkiwork, nomeMaestro, maestroData) => {
    setIdMaestro(maestroIdSkiwork);
    setNomeMaestro(nomeMaestro);
    setMaestroData(maestroData);
    setIsMaestroMode(true);
    setShowMaestriModal(false);
  };

  // Handler for first day timeline that properly accesses current state
  const handleFirstDaySlotClick = (slot) => {
    setTimeRangeFirstDay((prevRange) => {
      return updateTimeRangeWithSlot(prevRange, slot);
    });
  };

  const handleMainCalendarDateChange = (date) => {
    if (date) {
      setSelectedDates((prevDates) => {
        // Check if date already exists in the array
        const dateExists = prevDates.some((existingDate) =>
          moment(existingDate).isSame(date, "day")
        );

        let newDates;
        if (dateExists) {
          // Remove the date if it already exists
          newDates = prevDates.filter(
            (existingDate) => !moment(existingDate).isSame(date, "day")
          );
        } else {
          // Add the new date
          newDates = [...prevDates, moment(date)];
        }

        // Sort the array by date
        const sortedDates = newDates.sort((a, b) => moment(a).diff(moment(b)));

        // Check if we have a new lowest date
        const currentLowestDate =
          prevDates.length > 0
            ? prevDates.sort((a, b) => moment(a).diff(moment(b)))[0]
            : null;
        const newLowestDate = sortedDates.length > 0 ? sortedDates[0] : null;

        if (
          newLowestDate &&
          (!currentLowestDate ||
            !moment(newLowestDate).isSame(currentLowestDate, "day"))
        ) {
          setPrimoGiorno(newLowestDate);
          setTimeRangeFirstDay(null); // Clear time range when changing the first day
          // We have a new lowest date, fetch availability for it
          fetchAvailabilityForDay(newLowestDate);
        }

        return sortedDates;
      });
    }
  };

  const fetchAvailabilityForDay = async (date) => {
    try {
      // Format date to YYYY-MM-DD for API
      const formattedDate = moment(date).format("YYYY-MM-DD");

      // Call the API with parameters from Step 1
      const response = await privateNewApi.getDisponibilitàGiorno(
        formattedDate,
        selectedArea,
        selectedSpecialita,
        selectedLivello
      );

      // Transform API response to timeSlots format
      if (response && Array.isArray(response)) {
        setFirstDayTimeSlots(
          response.map((slot) => ({
            start: slot.dalle.slice(0, 5), // Convert "HH:mm:ss" to "HH:mm"
            end: slot.alle.slice(0, 5), // Convert "HH:mm:ss" to "HH:mm"
          }))
        );
      } else {
      }
    } catch (error) {
      console.error("Error fetching availability:", error);
    } finally {
      // setIsLoadingTimeSlots(false);
    }
  };

  const fetchBestAvailability = async () => {
    const datesWithoutFirst = selectedDates
      .filter((date) => !moment(date).isSame(primoGiorno, "day"))
      .map((date) => moment(date).format("YYYY-MM-DD"));
    const response = await privateNewApi.getDisponibilitaMigliore(
      moment(primoGiorno).format("YYYY-MM-DD"),
      timeRangeFirstDay.start,
      timeRangeFirstDay.end,
      selectedArea,
      selectedSpecialita,
      selectedLivello,
      datesWithoutFirst
    );

    console.log("Best availability response:", response);

    setDisponibilità(response.disponibilità);
    setIdMaestro(response.maestroId);
    // Note: timeRangesOtherDays will be populated by the useEffect
    // Reset only temp ranges since confirmed ranges will be handled by prepopulation logic
  };

  // Helper function to create time slots from disponibilità entry
  const createTimeSlotsFromDisponibilita = (dalle, alle) => {
    return [{ start: dalle, end: alle }];
  };

  // Helper function to handle time slot click for a specific day
  const createOtherDaySlotClickHandler = (data) => {
    return (slot) => {
      setTimeRangesOtherDays((prev) => {
        const currentTemp = prev[data] || null;
        const newRange = updateTimeRangeWithSlot(currentTemp, slot);

        return {
          ...prev,
          [data]: newRange,
        };
      });
    };
  };

  // Function to clear time range for a specific day
  const clearOtherDayTimeRange = (data) => {
    setTimeRangesOtherDays((prev) => {
      const newTemp = { ...prev };
      delete newTemp[data];
      return newTemp;
    });
  };

  // Function to handle lesson confirmation
  const handleConfirmLessons = () => {
    console.log("Confirming lessons:", prezziLezioni);
    console.log("Time ranges:", timeRangesOtherDays);
    // Add your confirmation logic here
    // For example, navigate to checkout or add to cart
  };

  // Function to render the floating lesson summary box
  const renderLessonSummary = () => {
    if (!prezziLezioni) return null;

    // Get the ordered list of lesson keys from prezziLezioni and sort them
    const orderedLessonKeys = Object.keys(prezziLezioni).sort();

    // Calculate total amount
    const totalAmount = Object.values(prezziLezioni).reduce(
      (sum, lesson) => sum + lesson.amount,
      0
    );
    const currency = Object.values(prezziLezioni)[0]?.currency || "EUR";

    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          right: "20px",
          transform: "translateY(-50%)",
          backgroundColor: "white",
          border: "2px solid #2185d0",
          borderRadius: "10px",
          padding: "20px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          zIndex: 1000,
          minWidth: "300px",
          maxWidth: "400px",
        }}
      >
        <h4
          style={{
            color: "#2185d0",
            marginTop: 0,
            marginBottom: "15px",
            textAlign: "center",
            borderBottom: "1px solid #e0e0e0",
            paddingBottom: "10px",
          }}
        >
          Riepilogo lezioni
        </h4>

        <div style={{ marginBottom: "15px" }}>
          {orderedLessonKeys.map((lessonKey) => {
            const lessonPrice = prezziLezioni[lessonKey];

            // Parse the lesson key format: 2025-10-08_1000_1130
            const [datePart, startTime, endTime] = lessonKey.split("_");
            const formattedStartTime = `${startTime.slice(
              0,
              2
            )}:${startTime.slice(2)}`;
            const formattedEndTime = `${endTime.slice(0, 2)}:${endTime.slice(
              2
            )}`;

            if (!lessonPrice) return null;

            return (
              <div
                key={lessonKey}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px 0",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: "bold", fontSize: "14px" }}>
                    {moment(datePart, "YYYY-MM-DD").format("DD/MM/YYYY")}
                  </div>
                  <div style={{ fontSize: "12px", color: "#666" }}>
                    {formattedStartTime} - {formattedEndTime}
                  </div>
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    color: "#2185d0",
                    fontSize: "14px",
                  }}
                >
                  {lessonPrice.amount.toFixed(2)} {lessonPrice.currency}
                </div>
              </div>
            );
          })}
        </div>

        <div
          style={{
            borderTop: "2px solid #2185d0",
            paddingTop: "10px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "15px",
          }}
        >
          <span style={{ fontWeight: "bold", fontSize: "16px" }}>Totale</span>
          <span
            style={{
              fontWeight: "bold",
              fontSize: "18px",
              color: "#2185d0",
            }}
          >
            {totalAmount.toFixed(2)} {currency}
          </span>
        </div>

        <Button
          primary
          fluid
          size="large"
          onClick={handleConfirmLessons}
          style={{
            backgroundColor: "#2185d0",
            marginTop: "10px",
          }}
        >
          Conferma
        </Button>
      </div>
    );
  };

  ////////////////
  // Refs
  const prevSelectedDatesRef = useRef();
  ////////////////
  //Side effects
  useEffect(() => {
    if (codScuola && lang) {
      // Load new school data
      loadSchoolDataNew(codScuola, lang);
      loadSchoolData(codScuola, lang);
    }
  }, [codScuola, lang]);

  // Initialize validation on first run when all preferences have values
  useEffect(() => {
    if (!hasBeenInitialized && validatePreferences()) {
      setIsPreferenzeValid(true);
      setHasBeenInitialized(true);
    }
  }, [
    selectedArea,
    selectedSpecialita,
    selectedLivello,
    selectedLingua,
    selectedNumAllevi,
    hasBeenInitialized,
  ]);

  // Invalidate when any preference changes (after initial validation)
  useEffect(() => {
    if (hasBeenInitialized && isPreferenzeValid) {
      setIsPreferenzeValid(false);
    }
  }, [
    selectedArea,
    selectedSpecialita,
    selectedLivello,
    selectedLingua,
    selectedNumAllevi,
  ]);

  useEffect(() => {
    if (isPreferenzeValid) {
      console.log("Preferences are valid, fetching unavailable days...");
      privateNewApi
        .getGiorniCompletamenteNonDisponibili(
          selectedArea,
          selectedSpecialita,
          selectedLivello,
          selectedLingua
        )
        .then((response) => {
          if (response && Array.isArray(response)) {
            setDateNonDisponibili(response);
          }
        })
        .catch((error) => {
          console.error("Error fetching unavailable days:", error);
        });
    }
  }, [isPreferenzeValid]);

  useEffect(() => {
    setDisponibilità([]);
    setIdMaestro(null);
    setPrezziLezioni(null);

    // Compute previous lowest date
    const prevLowest =
      prevSelectedDatesRef.current && prevSelectedDatesRef.current.length > 0
        ? prevSelectedDatesRef.current.sort((a, b) =>
            moment(a).diff(moment(b))
          )[0]
        : null;

    // Compute current lowest date
    const currentLowest =
      selectedDates.length > 0
        ? selectedDates.sort((a, b) => moment(a).diff(moment(b)))[0]
        : null;

    if (
      currentLowest &&
      (!prevLowest || !moment(currentLowest).isSame(prevLowest, "day"))
    ) {
      setTimeRangeFirstDay(null);
    }

    prevSelectedDatesRef.current = selectedDates;
  }, [selectedDates]);

  // Prepopulate first day's time range when disponibilità is loaded
  useEffect(() => {
    if (disponibilità?.length > 0 && timeRangeFirstDay) {
      // Helper function to check if a time range fits completely within a slot
      const timeRangeFitsInSlot = (
        rangeStart,
        rangeEnd,
        slotStart,
        slotEnd
      ) => {
        // Convert time strings to comparable format (remove seconds if present)
        const normalizeTime = (time) => time.slice(0, 5); // Get HH:mm

        const normalizedRangeStart = normalizeTime(rangeStart);
        const normalizedRangeEnd = normalizeTime(rangeEnd);
        const normalizedSlotStart = normalizeTime(slotStart);
        const normalizedSlotEnd = normalizeTime(slotEnd);

        const fits =
          normalizedRangeStart >= normalizedSlotStart &&
          normalizedRangeEnd <= normalizedSlotEnd;

        return fits;
      };

      // Prepopulate time ranges for all days where the first day's range fits
      setTimeRangesOtherDays((prev) => {
        const newRanges = {};

        disponibilità.forEach((day) => {
          const { data, dalle, alle } = day;

          // Check if this day already has confirmed ranges
          if (prev[data] && prev[data].length > 0) {
            // Keep existing ranges
            console.log(
              `Day ${data} already has ranges, keeping them:`,
              prev[data]
            );
            newRanges[data] = prev[data];
          } else {
            // Check if the first day's time range fits in this day's slot
            if (
              timeRangeFitsInSlot(
                timeRangeFirstDay.start,
                timeRangeFirstDay.end,
                dalle,
                alle
              )
            ) {
              // Prepopulate with first day's time range
              console.log(
                `Prepopulating day ${data} with range:`,
                timeRangeFirstDay
              );
              newRanges[data] = {
                start: timeRangeFirstDay.start,
                end: timeRangeFirstDay.end,
              };
            }
            // If it doesn't fit, leave it empty (don't add to newRanges)
            else {
              console.log(`Day ${data} range doesn't fit, leaving empty`);
            }
          }
        });

        return newRanges;
      });
    }
  }, [disponibilità, timeRangeFirstDay]);

  useEffect(() => {
    if (Object.keys(timeRangesOtherDays).length !== 0) {
      console.log("timeRangesOtherDays changed:", timeRangesOtherDays);

      // Make async API call to calculate price
      const calculatePrice = async () => {
        try {
          const result = await privateNewApi.calcolaPrezzoLezioniPrivate(
            timeRangesOtherDays,
            selectedNumAllevi,
            selectedSpecialita
          );
          console.log("Price calculation result:", result);
          setPrezziLezioni(result);
        } catch (error) {
          console.error("Error calculating price:", error);
        }
      };

      calculatePrice();
    }
  }, [timeRangesOtherDays, selectedNumAllevi, selectedSpecialita]);

  if (loading) {
    return (
      <Container>
        <div className="head-offset"></div>
        <TestataPagina
          titolo={t("lezioni_private")}
          icon="user"
          sottoTitolo={t("scegli_preferenze_private")}
        />
        <Segment>
          <Loader active inline="centered" />
        </Segment>
      </Container>
    );
  }

  return (
    <Container>
      <div className="head-offset"></div>
      <TestataPagina
        titolo={t("lezioni_private")}
        icon="user"
        sottoTitolo={t("scegli_preferenze_private")}
      />
      <Segment>
        <Grid stackable columns={2}>
          <Grid.Column width={4}>
            {!isMaestroMode && (
              <>
                <Preferenze
                  datiScuola={datiScuola}
                  selectedArea={selectedArea}
                  setSelectedArea={setSelectedArea}
                  selectedSpecialita={selectedSpecialita}
                  setSelectedSpecialita={setSelectedSpecialita}
                  selectedLivello={selectedLivello}
                  setSelectedLivello={setSelectedLivello}
                  selectedLingua={selectedLingua}
                  setSelectedLingua={setSelectedLingua}
                  selectedNumAllevi={selectedNumAllevi}
                  setSelectedNumAllevi={setSelectedNumAllevi}
                />
                <div style={{ textAlign: "center" }}>
                  <p>Vuoi un maestro specifico?</p>
                  <Button primary onClick={handleOpenMaestriModal}>
                    SCEGLILO QUI
                  </Button>
                </div>
              </>
            )}
            {!isPreferenzeValid && hasBeenInitialized && (
              <Message info>
                <Button onClick={handleRecalculate}>
                  {t("Ricalcola disponibilità")}
                </Button>
              </Message>
            )}
            {isMaestroMode && (
              <div style={{ textAlign: "center" }}>
                <Message positive>
                  <Message.Header>Maestro Selezionato</Message.Header>
                  {maestroData?.picture && (
                    <div style={{ marginBottom: "15px" }}>
                      <Image
                        src={`https://skiwork.blob.core.windows.net/webimg/${datiScuolaOld?.codiceScuola?.toUpperCase()}/Maestri/${
                          maestroData.picture
                        }`}
                        size="small"
                        circular
                        centered
                        style={{
                          maxWidth: "150px",
                          maxHeight: "150px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  )}
                  <h2>{nomeMaestro}</h2>
                  <Button
                    secondary
                    onClick={() => {
                      setIsMaestroMode(false);
                      setIdMaestro(null);
                    }}
                  >
                    TORNA INDIETRO
                  </Button>
                </Message>
              </div>
            )}
          </Grid.Column>
          {/* Right column */}
          <Grid.Column textAlign="center" width={12}>
            {/* <Timeline
              timeSlots={[{ end: "12:30", start: "09:00" }]}
              tempTimeRange={timeRangeFirstDay}
              onTimeSlotClick={handleFirstDaySlotClick}
              onClearTimeRange={() => setTimeRangeFirstDay(null)}
              getSelectionInstructionText={() =>
                "Seleziona l'orario per le lezioni"
              }
              showConfirmButton={true}
              onTimeRangeConfirm={async () => {
                await fetchBestAvailability();
              }}
              minHour={datiScuola.orarioDalle}
              maxHour={datiScuola.orarioAlle}
              data="08/11/2024"
            /> */}

            <Calendar
              isPreferenzeValid={isPreferenzeValid}
              dateNonDisponibili={dateNonDisponibili}
              selectedDates={selectedDates}
              onDateChange={handleMainCalendarDateChange}
            />
            <Divider />
            {isPreferenzeValid &&
              selectedDates?.length > 0 &&
              disponibilità?.length === 0 && (
                <>
                  <h3>Orario lezioni per il primo giorno</h3>
                  <Timeline
                    timeSlots={firstDayTimeSlots}
                    tempTimeRange={timeRangeFirstDay}
                    onTimeSlotClick={handleFirstDaySlotClick}
                    onClearTimeRange={() => setTimeRangeFirstDay(null)}
                    getSelectionInstructionText={() =>
                      "Seleziona l'orario per le lezioni"
                    }
                    showConfirmButton={true}
                    onTimeRangeConfirm={async () => {
                      await fetchBestAvailability();
                    }}
                    minHour={datiScuola.orarioDalle}
                    maxHour={datiScuola.orarioAlle}
                  />
                </>
              )}
            {disponibilità?.length > 0 && (
              <div style={{ marginTop: "20px" }}>
                {console.log(
                  "Rendering disponibilità section. timeRangesOtherDays:",
                  timeRangesOtherDays
                )}
                <h3>
                  Conferma l'orario delle lezioni per ogni giorno selezionato
                </h3>
                {/* <Message info>
                  <Message.Header>Orario lezioni</Message.Header>
                  <p>
                    Conferma l'orario delle lezioni per ogni giorno selezionato
                  </p>
                </Message> */}
                {disponibilità.map((disp, index) => {
                  const { data, dalle, alle } = disp;
                  const timeSlots = createTimeSlotsFromDisponibilita(
                    dalle,
                    alle
                  );
                  const tempRange = timeRangesOtherDays[data] || null;

                  return (
                    <div
                      key={`${data}-${index}`}
                      style={{ marginBottom: "5px" }}
                    >
                      {/* <Divider /> */}
                      {/* <h3 style={{ textAlign: "center", marginBottom: "15px" }}>
                        {moment(data).format("DD/MM/YYYY")} -{" "}
                        {t("disponibilita") || "Disponibilità"}: {dalle} -{" "}
                        {alle}
                      </h3> */}

                      <Timeline
                        data={moment(data).format("DD/MM/YYYY")}
                        timeSlots={timeSlots}
                        tempTimeRange={tempRange}
                        onTimeSlotClick={createOtherDaySlotClickHandler(data)}
                        onClearTimeRange={() => clearOtherDayTimeRange(data)}
                        getSelectionInstructionText={() => ""}
                        showConfirmButton={false}
                        minHour={datiScuola.orarioDalle}
                        maxHour={datiScuola.orarioAlle}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </Grid.Column>
        </Grid>
      </Segment>
      {/* Floating lesson summary box */}
      {renderLessonSummary()}

      {/* Maestri Selection Modal */}
      <GrigliaMaestri
        isOpen={showMaestriModal}
        onClose={handleCloseMaestriModal}
        onSelectMaestro={handleSelectMaestro}
        idScuola={datiScuolaOld?.id}
        codScuola={datiScuolaOld?.codiceScuola}
      />
    </Container>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    codScuola: ownProps.match.params.slug,
    lang: ownProps.match.params.lang,
    datiScuola: state.scuolaNewReducer,
    datiScuolaOld: state.scuolaReducer,
    loading: state.apiCallsInProgress > 0,
  };
}

const mapDispatchToProps = {
  setLang: appActions.setLang,
  setSlug: appActions.setSlug,
  clearAppData: appActions.clearAppData,
  loadSchoolData: scuolaActions.loadSchoolData,
  loadSchoolDataNew: scuolaNewActions.loadSchoolDataNew,
  addPrivataNew: cartActions.addPrivataNew,
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateNewMain);
